<ion-header class="balanced-title-header title-content-gap ion-no-border">
  <ion-toolbar class="header_toolbar">
    <div class="balanced-title-row">
      <ion-back-button class="balanced-title-back" defaultHref="/login" icon="chevron-back-outline" text=""></ion-back-button>
      <h1 class="balanced-title">Reminder Sent</h1>
    </div>
  </ion-toolbar>
</ion-header>

<ion-content class="content-padding"  >
  <ion-list class="login-form-list">


    <div class="es_image_wrapper">
      <img class="es_image" src="assets/sign_up_sign_in/email_reminder2x.png">
    </div>

    <div class="es_outline_text_wrapper">
      <div class="es_circle"><div class="es_exclam">!</div></div>
      If you have an account with that email address then we've just sent you a link to reset your password. Check your mail box.
    </div>

  </ion-list>
</ion-content>




<ion-footer class="onboarding-footer">
  <ion-toolbar>
    <div padding>
      <ion-button expand="block" class="submit-button" (click)="goLogin()">Back To Login</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
